import { useCallback, useEffect, useState } from 'react'
import { supabase } from '@/lib/supabase'
import { createRealtimeReloadScheduler } from '@/lib/realtimeReload'
import { fetchUnreadNotificationsCount } from '@/lib/notificationsEngine'

// Unread-notifications count for the sidebar bell badge. Same source and realtime contract as
// useNotifications (per-user rows, rare events, cheap query) but a HEAD count, so the layout
// never pulls inbox rows. The channel also fires on the mark-read UPDATE, which is what clears
// the badge moments after the user opens the inbox.
export function useUnreadNotificationsCount(): number {
  const [count, setCount] = useState(0)

  const load = useCallback(async () => {
    setCount(await fetchUnreadNotificationsCount())
  }, [])

  useEffect(() => {
    void load()
    const scheduler = createRealtimeReloadScheduler(() => void load(), { delayMs: 2_000 })
    const ch = supabase
      .channel('notifications-badge')
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'notifications' },
        scheduler.poke,
      )
      .subscribe()
    return () => {
      scheduler.dispose()
      void supabase.removeChannel(ch)
    }
  }, [load])

  return count
}
